import baseRules from './src/baseRules';

export { ValidateRule } from './src/baseRules';
export { useRules, defaultRules } from './src/extendRules';

export default baseRules;
